<div class="modal-header">
  <h4 class="modal-title">{{ dialogValues?.title }}</h4>
  <button
    type="button"
    class="btn btn-dark"
    aria-label="Close"
    style="margin-left: auto"
    (click)="activeModal.dismiss('Cross click')"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="col-sm-12" *ngFor="let fileObject of userInputValue">
    <div class="form-group row">
      <label class="text-right form-label">
        Name : {{ fileObject.fullName }}
      </label>
    </div>
    <div class="form-group row">
      <label [for]="fileObject.name" class="col-sm-2 text-right form-label">
        Description :
      </label>
      <div class="col-sm-5">
        <input
          type="text"
          [value]="fileObject.description"
          [disabled]="fileObject.isUploaded == true && userAction != 'EDIT'"
          class="form-control"
          (keyup)="fileDescription(fileObject, $event.target.value)"
          [id]="fileObject.name"
          placeholder="Description goes here"
        />
      </div>
      <label
        (click)="openFilePreview(fileObject.file)"
        [for]="fileObject.name"
        class="col-sm-1 text-center form-label"
      >
        <i class="mdi mdi-eye"></i>
      </label>
      <label
        (click)="downloadFile(fileObject)"
        [for]="fileObject.name"
        class="col-sm-1 text-center form-label"
      >
        <i class="mdi mdi-download"></i>
      </label>
      <label
        (click)="removeFile(fileObject)"
        [for]="fileObject.name"
        *ngIf="userAction == 'EDIT'"
        class="col-sm-1 text-center form-label"
      >
        <i class="mdi mdi-close"></i>
      </label>
    </div>
    <hr />
  </div>
  <!-- <div
    class="row input-group text-center"
    *ngIf="userAction == 'EDIT' || userAction == 'ADD'"
  >
    <input
      type="file"
      class="custom-file-input"
      id="documentsInput"
      multiple
      accept="image/jpeg,image/png,application/pdf"
      (change)="setDocuments($event.target.files)"
    />
    <label class="custom-file-label" for="documentsInput"> Document</label>
    <label class="custom-file-label" for="documentsInput"
      >Add New Documents
    </label>
  </div> -->

  <div
    class="row input-group text-center"
    *ngIf="userAction == 'EDIT' || userAction == 'ADD'"
  >
    <div class="d-flex align-items-center">
      <input
        class="custom-input-document form-control"
        type="file"
        id="documentsInput"
        multiple
        accept="image/jpeg,image/png,application/pdf"
        (change)="setDocuments($event.target.files)"
      />
    </div>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-success no-shadow" (click)="onSubmit()" type="button">
    Submit
  </button>
  <button
    type="button"
    class="btn btn-danger"
    (click)="activeModal.close('Close click')"
  >
    Close
  </button>
</div>
